import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { DEFAULT_SLIPPAGE } from "#/config/settings";

export const slippagePercentageAtom = atomWithStorage<number>(
  "slippagePercentage",
  DEFAULT_SLIPPAGE,
);

export const useSlippagePercentage = () => {
  const [slippagePercentage, setSlippagePercentage] = useAtom(
    slippagePercentageAtom,
  );

  const slippageFactor = slippagePercentage / 100;
  return {
    slippagePercentage,
    slippageFactor,
    setSlippagePercentage,
  };
};
